(function () {
  "use strict";
  console.log("DI");
  function DI() {
    var context = this;
    context.domLoaded = false;
    context.domLoadedCallbacks = [];
    var counter = 1;
    context.init = function () {
      console.log("DI");
      if (typeof (window.DI) == "object") {
        console.warn("window.DI namespace already taken. DI class didn't load");
      } else {
        window.DI = {
          DI: context
        };

        if (document.readyState === "interactive" || document.readyState === "complete") {
          context.domLoaded = true;
          context.fireCallbacks();
        } else {
          document.addEventListener("readystatechange", function (event) {
            if (document.readyState === "interactive") {
              context.domLoaded = true;
              context.fireCallbacks();
            }
          }, false);
        }
      }
    };

    context.injectReference = function (classNameString, ref) {
      window.DI[classNameString] = ref;
      return ref;
    };

    context.fireCallbacks = function () {
      for (var i = 0; i < context.domLoadedCallbacks.length; i++) {
        context.domLoadedCallbacks[i]();
      }
    };

    context.subscribeDOMLoaded = function (cb) {
      if (context.domLoaded) {
        cb();
      } else {
        context.domLoadedCallbacks.push(cb);
      }
    };
    context.callAngularCalculateOrder = function () {
      // create an injector
      angular.element(document.body).ready(function () {
        angular.element(document.body).injector().invoke(['$rootScope', function ($rootScope) {
          $rootScope.$emit('callcalculateorder');
        }]);
      });
    };
    context.callAngularCalculateAutoOrder = function () {
      // create an injector
      angular.element(document.body).ready(function () {
        angular.element(document.body).injector().invoke(['$rootScope', function ($rootScope) {
          $rootScope.$emit('callcalculateautoorder');
        }]);
      });
    };
    context.notification = function (title, message, type, from, align, icon, animIn, animOut, delay) {
        let styling = "rgb(11 175 0)";
        if(type == 'error') {
        styling = "rgb(227 33 33)";
        }
        Toastify({
            text: message,
            duration: delay || 3000,
            close: true,
            gravity: "top",
            position: "right",
            style: { background: styling }
        }).showToast();


//       $('#myToast').remove();
//       $(document.body).append(`<div class="toast ${type || 'primary'} ${align || 'right-top'}" data-autohide="true"  data-delay="${delay || 1000}" id="myToast${counter}">
//       <div class="toast-header">
//           <strong class="me-auto"><i class="bi-gift-fill"></i> ${title}</strong>
//           <small></small>
//           <button type="button" class="btn-close" data-dismiss="toast" aria-label="Close"></button>
//       </div> 
//       <div class="toast-body">
//       ${message}
//       </div>
//   </div>`);
//       $(`#myToast${counter}`).toast('show');
//       counter = counter + 1;
    };
  }

  window.DIMainInstance = new DI();
  window.DIMainInstance.init();
})();


